/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import {
  ConfigurationHelper,
  IApplicationMenuItemComponentModel,
} from "@nf/common";
import React from "react";
import cx from "classnames";

import Button from "components/Button";

import styles from "./ApplicationMenu.module.scss";

export interface ApplicationMenuProps {
  className?: string;
  components?: IApplicationMenuItemComponentModel[];
  activeComponent?: IApplicationMenuItemComponentModel;
}

export const ApplicationMenu = ({
  className,
  components,
  activeComponent,
}: ApplicationMenuProps) => {
  return (
    <div className={cx(styles.menu, className)}>
      {components?.map((component) => {
        const screenKey = ConfigurationHelper.getScreenRouteKey(
          component?.Action?.ScreenId,
          component?.Action?.ScreenTypeCode
        );

        return (
          <Button
            key={component.Id}
            size="large"
            variant="tertiary"
            state={component.Id === activeComponent?.Id ? "active" : "default"}
            href={screenKey}
            icon={<img src={component.Icons?.compact} aria-hidden={true} />}
          >
            {component.Title}
          </Button>
        );
      })}
    </div>
  );
};

export default ApplicationMenu;
